<template>
  <table class="table is-fullwidth">
    <tr>
      <td style="width: 300px;">Name</td>
      <td>{{ user.name }}</td>
    </tr>

    <tr>
      <td>Email</td>
      <td>{{ user.email }}</td>
    </tr>

    <tr>
      <td>Verification Status</td>
      <td>
        <span class="tag is-primary" v-if="user.verified">Verified</span>

        <span class="tag" v-else>Unverified</span>
      </td>
    </tr>

    <tr>
      <td>Gender</td>
      <td>{{ user.gender }}</td>
    </tr>

    <tr>
      <td>Birth date</td>
      <td>{{ user.birth_date }}</td>
    </tr>

    <tr>
      <td>Phone</td>
      <td>{{ user.phone_dial_code }} {{ user.phone }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  props: ["user"],


  data() {
    return {};
  },

  methods: {}
};
</script>
